import angular from 'angular'
import breadcrumbDirective from './breadcrumbDirective'

export default angular
  .module('app.breadcrumb', [])
  .directive('breadcrumb', ['$state', '$timeout', breadcrumbDirective]).name



// WEBPACK FOOTER //
// ./src/components/breadcrumb/index.js